const menuRoutes = [
	{ path: "/", name: "Home", ttoken: "menu.home", icon: "home" }
	// { path: "/map", name: "map", ttoken: "menu.map", icon: "map" }
];

export default menuRoutes;